import React, { useState, useEffect, useRef, Fragment } from "react";
import range from 'lodash/range';
import style from './datefield.module.css'
import Icons from '../../module.icons';
import { DateFormatter, DateTimeFormatter } from "../../../utils/dates";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {getYear, getMonth, parseISO} from 'date-fns';

function DateField(props) {
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [tempDate, setTempDate] = useState();

    useEffect(() => {
      if (props.value){
        setTempDate(props.value)
      }
    }, [props.value])
    
    useEffect(() => {
      let l;
      if (showDatePicker !== false) {
        l = document.addEventListener('click', function(event) {  
          if (event.target.closest(".dateFilter")) return 
          setShowDatePicker(false)
        } , true);
        
      } else {
       
        document.removeEventListener("click", l);
      }
      
    }, [showDatePicker])

    function clearDate(){
      setTempDate(null)
      props.onDateSelect(props.date_key, null)
    }

    const years = range(1990, getYear(new Date()) + 10, 1);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return (
        <div className={`flex flexColumn gap5 ${style.dateBox}`}>
        <span className="canvasLabel">{props.heading}</span>
        <div
          style={{
            display: "grid",
            alignItems: "center",
            gap: "20px",
            gridTemplateColumns: "160px 20px"
            // justifyContent: "center",
          }}
        >
        <span className={`field ui ${style.field}`} onClick={() => setShowDatePicker(props.date_key)}>{props.date? DateFormatter(new Date(DateTimeFormatter(props.date, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y") : <span className="fieldCta canvasLabel">{tempDate ? <Fragment>{DateFormatter(new Date(DateTimeFormatter(tempDate, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y")}</Fragment> : <Fragment>Add {props.name}</Fragment>}</span>}</span>
        {(showDatePicker === props.date_key) &&  <div className="dateFilterPos"><div className="dateFilter">

       { props.yearPicker ? 
        <DatePicker 
          renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button style={{border: 'none', marginRight: '5px'}} onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            <Icons.ChevronDown style={{transform: 'rotate(90deg)'}} />
          </button>
           <select
           style={{marginRight: '5px'}}
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

         

          <button style={{border: 'none', marginLeft: '5px'}} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
           <Icons.ChevronDown style={{transform: 'rotate(-90deg)'}} />
          </button>
        </div>
      )}  
       selected={props.value && parseISO(props.value)}
        className={style.datePicker}
        onChange={(date) => 
            props.onDateSelect(props.date_key, date)
        }
        onSelect={(date) => {
            setShowDatePicker(false)
            console.log("date", date)
            setTempDate(date)
            props.onDateSelect(props.date_key, date)
        }}
      inline
    /> :
          <DatePicker
          selected={props.date && parseISO(props.value)}
          className={style.datePicker}
          onChange={(date) => 
              props.onDateSelect(props.date_key, date)
          }
          onSelect={(date) => {
              setShowDatePicker(false)
              console.log("date", date)
              setTempDate(date)
              props.onDateSelect(props.date_key, date)
          }}
          inline
        />} </div></div>}

        <span style={{fontSize: '12px', cursor: 'pointer'}} onClick={() => clearDate()}>Clear</span>
        </div>
      </div>
    )
}

export default DateField;
